export class ObjectHelper {
  constructor() { }

  public isSubset(objectA: any, objectB: any) {
    if (typeof objectA !== 'object' || typeof objectB !== 'object') {
      return false
    }

    return Object.keys(objectB).every((key: string) => {
      return key in objectA && (objectB[key] === objectA[key] || this.isSubset(objectA[key], objectB[key]))
    })
  }

  public areMutualSubsets(objectA: any, objectB: any) {
    return this.isSubset(objectA, objectB) && this.isSubset(objectB, objectA)
  }

  public clone<T>(
    type: {new(): T},
    instance: T,
    defaultOptions: {include: string[], shallow?: string[]},
    options?: {exclude?: string[], include?: string[], shallow?: string[]}
  ): T {
    const opts = options || {}
    opts.exclude = Array.isArray(opts.exclude) ? opts.exclude : []
    opts.include = Array.isArray(opts.include) ? opts.include : defaultOptions.include
    opts.shallow = Array.isArray(opts.shallow) ? opts.shallow : defaultOptions.shallow || []

    opts.shallow = opts.shallow.filter((shallowAttribute) => ! opts.exclude.includes(shallowAttribute))
    opts.include = opts.include.filter((includedAttribute) => ! opts.exclude.includes(includedAttribute)
      && ! opts.shallow.includes(includedAttribute))

    const cloneValue = (value) => typeof value['clone'] === 'function' ? value.clone() : value
    const result = new type()

    let propertyCopy
    opts.include.forEach((propertyName) => {
      if (!(propertyName in instance)) { return }

      const propertyValueToCopy = instance[propertyName]
      if (Array.isArray(propertyValueToCopy)) {
        propertyCopy = propertyValueToCopy.map((arrayValue) => cloneValue(arrayValue))
      } else if (propertyValueToCopy instanceof Date) {
        propertyCopy = new Date(+propertyValueToCopy)
      } else if (typeof propertyValueToCopy === 'object' && propertyValueToCopy !== null) {
        propertyCopy = cloneValue(propertyValueToCopy)
      } else {
        propertyCopy = propertyValueToCopy
      }
      result[propertyName] = propertyCopy
    })
    opts.shallow.forEach((propertyName) => {
      if (!(propertyName in instance)) { return }
      const propertyValueToCopy = instance[propertyName]
      if (Array.isArray(propertyValueToCopy)) {
        result[propertyName] = [].concat(propertyValueToCopy)
      } else {
        result[propertyName] = propertyValueToCopy
      }
    })

    return result
  }

  public isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item)
  }

  public mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} })
          this.mergeDeep(target[key], source[key])
        } else {
          Object.assign(target, { [key]: source[key] })
        }
      }
    }

    return this.mergeDeep(target, ...sources)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/object-helper/object-helper.ts